var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerarrowvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 8.6123L29.8473 9.23267L31.4163 10.9296L19.3935 21.2568L13.081 18.2827L0 29.1209V33.0255L13.6283 21.713L19.9955 24.7418L33.2954 13.0096L34.9557 14.8342L35.9408 8.6123Z",
    fill: "url(#paint0_linear_4414_1358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5337 0L23.699 0.492643L24.9396 1.84285L15.398 10.0353L10.3809 7.66334L0 16.2937V19.3773L10.8187 10.4002L15.8723 12.7905L26.4356 3.48499L27.7492 4.92643L28.5337 0Z",
    fill: "url(#paint1_linear_4414_1358)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4414_1358",
    x1: 35.9408,
    y1: 33.0255,
    x2: -2.80093,
    y2: 28.1406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4414_1358",
    x1: 28.5337,
    y1: 19.3773,
    x2: -2.22346,
    y2: 15.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerarrowvector);
export default __webpack_public_path__ + "static/media/bannerarrowvector.67d8f26a7eed589c940644bade95a570.svg";
export { ForwardRef as ReactComponent };